export enum DocumentClass {
  AUTOMATIC = 'AUTOMATIC',
  INVOICE = 'INVOICE',
  CERTIFICATION = 'CERTIFICATION',
  CONTRACT = 'CONTRACT',
  PRESS_EXTRACT = 'PRESS_EXTRACT',
  BOOKLET = 'BOOKLET',
  CATALOG = 'CATALOG',
  PICTURE = 'PICTURE',
  ADVERTISING = 'ADVERTISING',
  WEBSITE_SCREENSHOT = 'WEBSITE_SCREENSHOT',
  ONLINE_STORE_SCREENSHOT = 'ONLINE_STORE_SCREENSHOT',
  ACCOUNTING_DOCUMENT = 'ACCOUNTING_DOCUMENT',
  EMAIL = 'EMAIL',
  AWARD = 'AWARD',
  OTHER = 'OTHER'
}